export const LIVE_SOUND_STORAGE_KEY = 'rp.live.sound'

const SOUND_ON = 'on'
const SOUND_OFF = 'off'
const TONE_FREQUENCY_HZ = 880
const TONE_GAIN = 0.1
const TONE_DURATION_S = 0.15

export const readSoundEnabled = (storage: Pick<Storage, 'getItem'>): boolean => {
  try {
    return storage.getItem(LIVE_SOUND_STORAGE_KEY) === SOUND_ON
  } catch {
    return false
  }
}

export const storeSoundEnabled = (storage: Pick<Storage, 'setItem'>, enabled: boolean): void => {
  try {
    storage.setItem(LIVE_SOUND_STORAGE_KEY, enabled ? SOUND_ON : SOUND_OFF)
  } catch {
    return
  }
}

const shared: { context: AudioContext | null } = { context: null }

export const releaseAlertTone = (): void => {
  const previous = shared.context
  shared.context = null
  void previous?.close().catch(() => undefined)
}

const toneContext = (): AudioContext | null => {
  if (typeof AudioContext === 'undefined') return null
  if (shared.context === null) shared.context = new AudioContext()
  if (shared.context.state === 'suspended') void shared.context.resume().catch(() => undefined)
  return shared.context
}

export const primeAlertTone = (): void => {
  try {
    toneContext()
  } catch {
    releaseAlertTone()
  }
}

export const playAlertTone = (): boolean => {
  try {
    const context = toneContext()
    if (context === null) return false
    const oscillator = context.createOscillator()
    const gain = context.createGain()
    oscillator.frequency.value = TONE_FREQUENCY_HZ
    gain.gain.value = TONE_GAIN
    oscillator.connect(gain)
    gain.connect(context.destination)
    oscillator.start()
    oscillator.stop(context.currentTime + TONE_DURATION_S)
    return true
  } catch {
    releaseAlertTone()
    return false
  }
}
